import { render, staticRenderFns } from "./desgloselibro.vue?vue&type=template&id=cb9d80a4"
import script from "./desgloselibro.vue?vue&type=script&lang=js"
export * from "./desgloselibro.vue?vue&type=script&lang=js"
import style0 from "./desgloselibro.vue?vue&type=style&index=0&id=cb9d80a4&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports